import * as React from 'react'
import { ColumnOption } from '../types'
import { getContrastColor } from '../../project_groups_columns/helpers'
import { CellRendererProps, ATTACHMENT_KEYS } from './types'

function renderBadge(value: string, column_options?: ColumnOption[]): React.ReactNode {
  const option = column_options?.find((opt) => opt.label === value)
  const displayLabel = option?.label ?? value
  const bgColor = option?.color || '#e9ecef'
  const textColor = getContrastColor(bgColor)

  return (
    <span
      key={value}
      className="badge mr-1 mb-1"
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      {displayLabel}
    </span>
  )
}

export function SelectCell({ value, column }: CellRendererProps): React.ReactNode {
  if (value == null || value === '') {
    return null
  }

  if (Array.isArray(value) && !ATTACHMENT_KEYS.includes(column.key)) {
    return (
      <span>
        {(value as string[]).map((v) => renderBadge(v, column.column_options))}
      </span>
    )
  }

  if (typeof value === 'string') {
    return renderBadge(value, column.column_options)
  }

  return null
}
